import React, { Component } from "react";
import { Form, Col } from "antd";
import { connect } from "dva";
import moment from "moment";
import router from "umi/router";
import ListPage from "@/components/ListPage";
import FormCreate from "@/components/FormCreate";
import Container from "@/components/Container";
import styles from "./index.less";

const { ListSearch, ListTable } = ListPage;
const { FormRangePicker, FormTitle } = FormCreate;

@Form.create()
@connect(({ securityPatrolList }) => ({
  ...securityPatrolList
}))
class index extends Component {
  constructor(props) {
    super(props);
    const columns = [
      {
        title: "巡查人",
        dataIndex: "userName"
      },
      {
        title: "巡查时长",
        dataIndex: "durationDesc"
      },
      {
        title: "巡查距离",
        dataIndex: "distance",
        render: distance => {
          return <span>{distance || "-"}米</span>;
        }
      },
      {
        title: "巡查时间",
        render: record => {
          const { startTime, endTime } = record;
          return (
            <span>
              {startTime} ~ {endTime}
            </span>
          );
        }
      }
    ];
    this.state = {
      searchValue: {
        startDate: moment().format("YYYYMMDD"),
        endDate: moment().format("YYYYMMDD"),
        userName: ""
      },
      columns
    };
  }

  componentDidMount() {
    this.getDataList();
  }

  // 分页改变
  handlePaginationChange = (page, pageSize) => {
    const pageInfo = { page, pageSize };
    this.getDataList(pageInfo);
  };

  getDataList = pageInfo => {
    const { dispatch } = this.props;
    const { searchValue } = this.state;
    dispatch({
      type: "securityPatrolList/fetchDataList",
      params: {
        page: 1,
        pageSize: 10,
        ...pageInfo,
        ...searchValue
      }
    });
  };

  // 重置时的回调
  handleReset = () => {
    this.setState(
      {
        searchValue: {
          startDate: moment().format("YYYYMMDD"),
          endDate: moment().format("YYYYMMDD"),
          userName: ""
        }
      },
      () => {
        this.getDataList();
      }
    );
  };

  // 点击搜索时的回调
  handleQuery = values => {
    const { form } = this.props;
    const { validateFields } = form;
    validateFields(err => {
      if (!err) {
        const { patrolDate, userName } = values;
        this.setState(
          {
            searchValue: {
              startDate: patrolDate[0].format("YYYYMMDD"),
              endDate: patrolDate[1].format("YYYYMMDD"),
              userName
            }
          },
          () => {
            this.getDataList();
          }
        );
      }
    });
  };

  // 跳转巡查详情
  handleGoDetail = id => {
    router.push(`/campusSafety/securityPatrol/list/detail?inspectionId=${id}`)
  }

  render() {
    const { form, spinProps, pageInfo, dataList } = this.props;
    const { columns } = this.state;

    const containerProps = {
      breStates: true,
      version: 2,
      isSplitBar: true
    };

    const formItemProps = {
      colon: true,
      labelCol: { span: 8 },
      wrapperCol: { span: 16 }
    };

    const pageProps = {
      className: styles.root,
      spinProps
    };

    const formDateProps = {
      form,
      value: [moment(), moment()],
      format: "YYYY.MM.DD",
      label: "巡查时间",
      keyName: "patrolDate",
      message: "请选择日期范围",
      disabledDate: false
      // formItemProps
    };

    const formTitleProps = {
      form,
      value: "",
      keyName: "userName",
      label: "巡查人",
      isRequired: false,
      placeholder: "请输入巡查人"
      // formItemProps
    };

    const listSearchProps = {
      form,
      className: "searchWrapper",
      handleReset: this.handleReset,
      handleQuery: this.handleQuery,
      buttonColProps: {
        style: {
          textAlign: "right"
        }
      },
      formLayoutProps: formItemProps
    };

    const listTableProps = {
      pageInfo,
      columns,
      list: dataList,
      onPageChange: this.handlePaginationChange,
      onItemClick: this.handleGoDetail
    };

    return (
      <Container {...containerProps}>
        <ListPage {...pageProps}>
          <ListSearch {...listSearchProps}>
            <Col span={8}>
              <FormRangePicker {...formDateProps} />
            </Col>
            <Col span={8}>
              <FormTitle {...formTitleProps} />
            </Col>
          </ListSearch>
          <ListTable {...listTableProps} />
        </ListPage>
      </Container>
    );
  }
}

export default index;
